import type { HomeSummary } from "@unbox/api";
import { formatMoneyShort, formatSignedMoneyShort } from "@/pages/workspace-overview/lib/format";
import { heroWhen } from "@/pages/workspace-overview/lib/period";
import type { DistributionRange } from "./ranges";

export type HeroHeadline = {
  gmv: string;
  change: { direction: "up" | "down"; percent: string; delta: string } | null;
  creators: string;
};

const creatorSentence = (count: number): string => {
  if (count === 0) return "No new creators posted for the first time.";
  if (count === 1) return "1 new creator posted for the first time.";
  return `${count} new creators posted for the first time.`;
};

export const heroHeadline = (
  summary: NonNullable<HomeSummary>,
  range: DistributionRange,
  currency: string,
): HeroHeadline => {
  const { current, prior, change } = summary.gmv;

  return {
    gmv: `${formatMoneyShort(current, currency)} GMV ${heroWhen(range)}`,
    change:
      prior === 0
        ? null
        : {
            direction: change >= 0 ? "up" : "down",
            percent: `${Math.abs(change).toFixed(1)}%`,
            delta: formatSignedMoneyShort(current - prior, currency),
          },
    creators: creatorSentence(summary.newCreators.current),
  };
};

export const heroHeadlineText = ({ gmv, change, creators }: HeroHeadline): string =>
  [gmv, change && `${change.direction} ${change.percent} (${change.delta})`, creators].filter(Boolean).join(" ");
